import { HostBinding,Renderer2,HostListener,AfterViewChecked,ChangeDetectorRef,ElementRef,ViewChild,ViewChildren,QueryList,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation} from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {NewsletterService} from '../../services/newsletter.service';
import {IRule} from '../../irule';
import {ArticleService} from '../../services/article.service';
import * as moment from 'moment';


declare var $:any;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent extends BaseComponent implements OnInit,OnDestroy,AfterViewInit,IRule{

  @HostBinding('style.width') public width: string = '100%';

  newsletterHeight:string='444px';

  msg:any;
  toast:any;
  dropdownSettings = {};
  url:any=AppSettings.API_ENDPOINT;
  userName:any;
  navigationsType:Array<any>= [];
  categoryList:Array<any>= [];
  typeList:Array<any>= [];
  selectedCategory:any=[];
  selectedType:any=[];
  currentTab:number=1;
  currentText:string='Articles';
  count:number=0;


   page_load_article:boolean = false;
   page_load_newsletter:boolean = false;


   newsletter_offset:number= 0;
   article_offset:number= 0;

  record_offset:number= 0;


  per_page:number=8;
  articleList:Array<any>=[];
  newsletterList:Array<any>=[];
  articleFrom:any='';
  articleTo:any='';
  newsTo:any='';
  newsFrom:any='';
  search:any ='';
  notification:any=[];

  loader_image:boolean=true;

  paramCategory:any;

  selectedTypeVal:any
  

  subscription:Subscription;

  source:any;

  constructor(msg:MessageService, toastr: ToastrService,homeservice:HomeService,private _router: Router,private route:ActivatedRoute,private newsletter:NewsletterService,private articleService:ArticleService) {

    super(msg,toastr,homeservice,_router);

    this.msg=msg;
    this.toast = toastr;

	  try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      let data={
        token:tokenA.token
      }

      this.articleService.getCategoryList(data).subscribe( (result)=>{



        if(result.status=='success'){
           this.categoryList = result.category
           this.navigationsType = result.navigation;
           this.userName = result.user.name;
           this.notification=result.notification;
           this.broadcast_menu();

           this.articleService.getCategoryType(data).subscribe( (res)=>{

            if(res.status=='success'){

              this.typeList=res.type;

              this.route.queryParams.subscribe(params =>{

                    if(params.source!=undefined){
                      this.source = params.source;
              
                    }

                    if(params.type!=undefined){
                      
                      let typestr = this.typeList.find( (item) =>{ return item.key == params.type;});
                      let arr = []
                      arr.push(typestr)
                      
                      this.selectedType = []

                      this.selectedType = arr
                    }

                    if(params.category!=undefined){

                      this.paramCategory = params.category

                      if(params.source == undefined){
                        this.msg.sendMessage({type:'customeEvent',event:'category',value:params.category,source:'search'});
                      }

                      if(this.paramCategory!=undefined){

                        let type = this.paramCategory
                        let typestr = this.categoryList.find( (item) =>{ return item.key == type;});
                        let arr = []
                        arr.push(typestr)
                        this.loader_image=true;

                       this.selectedCategory = []

                       this.selectedCategory = arr

                       this.newsletter_offset= 0;
                       this.article_offset= 0;
                       this.articleList=[];
                       this.newsletterList=[];

                       if(this.currentTab ==1){

                        this.page_load_article= false;
                        this.page_load_newsletter = true;

                      
                        this.callApi(this.currentTab)

                       }else{

                        this.page_load_article= true;
                        this.page_load_newsletter = false;

                        this.callApi(this.currentTab)

                       }





                      }

                    } else if(params.tag!=undefined && params.category ==undefined && this.search==''){

                      this.loader_image=true;

                      this.newsletter_offset= 0;
                      this.article_offset= 0;
                      this.search = params.tag
                       this.articleList=[];
                       this.newsletterList=[];


                      if(this.currentTab ==1){

                        this.page_load_article= false;
                        this.page_load_newsletter = true;

                        this.callApi(this.currentTab)

                       }else{

                        this.page_load_article= true;
                        this.page_load_newsletter = false;

                        this.callApi(this.currentTab)

                       }

                    }




                })

            }else{
              this.toast.error('Article Type Not Found  !', '', {timeOut: 3000});
            }
          })



        }else{
          this.toast.error('Category List Not Found  !', '', {timeOut: 3000});
        }

      })





    }catch(exec){

    }



    this.subscription = this.msg.getMessage().subscribe(message => {




      if(message!=undefined && message!=false && message.text.type=="search"){

        this.loader_image=true;
        this.search = message.text.details;

        if(message.text.currentPage!=undefined){

          this.msg.sendMessage({type:'customeEvent',event:'search',value:message.text.details,source:message.text.currentPage});

        }

       
         $('#newsletter_scroll').css('height',this.newsletterHeight);

        this.newsletter_offset= 0;
        this.article_offset= 0;
        this.selectedCategory = []
        this.selectedType = []
         this.articleList=[];
         this.newsletterList=[];
        if(this.currentTab ==1){

          this.page_load_article= false;
          this.page_load_newsletter = true;

          this.callApi(this.currentTab)

         }else{

          this.page_load_article= true;
          this.page_load_newsletter = false;

          this.callApi(this.currentTab)

         }



      } else {


		      if(message ==undefined && this.route.snapshot.queryParams.category ==undefined){

             $('#newsletter_scroll').css('height',this.newsletterHeight);



            this.loader_image=true;
					  this.search = '';

						this.newsletter_offset= 0;
						this.article_offset= 0;
						 this.articleList=[];
						 this.newsletterList=[];
            if(this.currentTab ==1){

              this.page_load_article= false;
              this.page_load_newsletter = true;

              this.callApi(this.currentTab)

             }else{

              this.page_load_article= true;
              this.page_load_newsletter = false;

              this.callApi(this.currentTab)

             }
		      }

		  }



    })



   }


 


   get_title_type(type_str:string){

    if(this.typeList){

      let typestr = this.typeList.find( (item) =>{ return item.key == type_str;});

      return (typestr!=undefined)?typestr.value:'';

    }

  }

   onCategorySelect(event:any){

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
    this.articleList=[];
    this.newsletterList=[];

     this.callApi(this.currentTab)
   }

   onCategorySelectAll(event:any){

    this.selectedCategory = this.categoryList;

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

    this.callApi(this.currentTab)

   }

   onCategoryDeSelect(event:any){

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

    this.callApi(this.currentTab)

   }

   onCategoryDeSelectAll(event:any){

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

     this.selectedCategory = []

     this.callApi(this.currentTab)

   }

   onTypeSelect(event:any){

    this.selectedTypeVal = event.key
    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

    this.callApi(this.currentTab)

   }

   onTypeSelectAll(event:any){

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

    this.selectedType = this.typeList

    this.callApi(this.currentTab)

   }

   onTypeDeSelect(event:any){

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

    this.callApi(this.currentTab)

   }

   onTypeDeSelectAll(event:any){

    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
     this.articleList=[];
     this.newsletterList=[];

    this.selectedType = []

    this.callApi(this.currentTab)

   }

   tab(id){

    if(id==1){
      this.currentText='Articles'
    }else{
      this.currentText='Newsletters'


    }

    if(this.currentTab!=id){

      this.loader_image=true;

      this. articleFrom='';
      this.articleTo='';
      this.newsTo='';
      this.newsFrom='';
      this.selectedCategory = [];
      this.selectedType = [];
      this.currentTab = id;
      this.newsletter_offset= 0;
      this.article_offset= 0;
      this.page_load_article = true;
      this.page_load_newsletter = true;
      this.articleList=[];
      this.newsletterList=[];

      this.callApi(this.currentTab)




    }


   }


  changeArticleFrom(){

    this.changeArticleTo()
  }

  changeArticleTo(){


    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
    // this.articleList=[];
    // this.newsletterList=[];

    if(this.articleFrom==''){

      this.toast.warning('Please choose from date !', '', {timeOut: 3000});

    }else if(this.articleFrom!='' && this.articleTo!='' && this.articleFrom>=this.articleTo){

      this.toast.warning('To date must be greater than from date !', '', {timeOut: 3000});

    }else{
      this.callApi(this.currentTab)
    }

  }

  changeNewsFrom(){

    this.changeNewsTo()
  }

  changeNewsTo(){


    this.page_load_article= true;
    this.page_load_newsletter = true;
    this.newsletter_offset= 0;
    this.article_offset= 0;
    // this.articleList=[];
    // this.newsletterList=[];

    if(this.newsFrom==''){

      this.toast.warning('Please choose from date !', '', {timeOut: 3000});

    }else if(this.newsFrom!='' && this.newsTo!='' && this.newsFrom>=this.newsTo){

      this.toast.warning('To date must be greater than from date !', '', {timeOut: 3000});

    }else{
      this.callApi(this.currentTab)
    }

  }

  callApi(currentTab){

    try{


     // console.log('rr2',this.newsletter_offset);


      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      if(currentTab ==1){

       // this.page_load_article =false;
        this.loader_image=true;

        let data={
          token:tokenA.token
        }

        data['page']='search';


        if(this.articleFrom!='' && this.articleTo!='' ){
           data['from'] = this.articleFrom
           data['to'] = this.articleTo
        }
        let categories = []





        this.selectedCategory.forEach(element => {
          if(element && element.key!=undefined){
            categories.push(element.key);
          }else{
            categories.push(element);
          }

        });

        let unique = [...new Set(categories)];

        data['category'] = unique

        let types= [];

        this.selectedType.forEach(element => {

          types.push(element.key);

        });

        data['type'] = types;

        data['search'] = this.search
        data['limit'] =this.per_page
        data['offset']=this.article_offset

        if(this.source!=undefined){
          data['source']=this.source
        }
       
        let data2={
          token:tokenA.token,
          desc: data
        };

        this.articleService.articleDataFiltered(data2).subscribe( (response) =>{

          if(response.status == 'success'){


            this.loader_image=false;

            this.count = response.count;



            if(response.article.length ==0 && this.article_offset==0){


              this.page_load_article =false;

              this.articleList = response.article;




              // if(this.article_offset==0){
              //   this.articleList = response.article;
              // }


            } else if(this.articleList.length==0 && response.article.length!=0){


              this.articleList = response.article;

              this.page_load_article =true;

              if(this.article_offset ==0){

                this.article_offset+=this.per_page;

              }




            } else if(this.articleList.length!=0 && response.article.length!=0 && this.article_offset !=0){



              response.article.forEach(element => {


                this.articleList.push(element);



              });

              this.page_load_article =true;



            } else if(this.article_offset!=0 && response.article.length ==0 )  {


              this.page_load_article =false;


            }









          }else{
           this.toast.error('Article List Not Found  !', '', {timeOut: 3000});
          }

       })


      }else{


     //   this.page_load_newsletter =false;

        this.loader_image=true;

        let data;
        let data2={

        }
        if(this.newsFrom!='' && this.newsTo!=''){





           data={
            from:this.newsFrom,
            to:this.newsTo,
            search: this.search,
            limit:this.per_page,
            offset:this.newsletter_offset,
            page:'search'

           }
           data2['token'] =tokenA.token

           data2['reqData'] =data
           if(this.source!=undefined){
            data2['source']=this.source
          }

        }else{

          data2['token'] =tokenA.token,
          data2['reqData'] = {
            search: this.search,
            limit:this.per_page,
            offset:this.newsletter_offset,
            page:'search'
          }

          if(this.source!=undefined){
            data2['source']=this.source
          }
        }

        this.newsletter.newsletterData(data2).subscribe( (response)=>{

          if(response.status == 'success'){

            this.loader_image=false;

            this.count = response.count;


            if(response.newsletter.length ==0 && this.newsletter_offset ==0){



                this.page_load_newsletter =false;


                this.newsletterList = response.newsletter;

                $('#newsletter_scroll').css('height', '0px');


            }

            else if(this.newsletterList.length==0 && response.newsletter.length!=0){


              if(response.newsletter.length > 4){
                $('#newsletter_scroll').css('height', '777px');

              }else{

                $('#newsletter_scroll').css('height', '444px');
              }


             this.newsletterList = response.newsletter;

             this.page_load_newsletter =true;

             if(this.newsletter_offset ==0){

              this.newsletter_offset+=this.per_page;

            }





            }else if(this.newsletterList.length!=0 && response.newsletter.length!=0 && this.newsletter_offset !=0){



              if(response.newsletter.length > 0){


                if(response.newsletter.length > 4){
                  $('#newsletter_scroll').css('height', $('#newsletter_scroll').height()+777);

                }else{

                  $('#newsletter_scroll').css('height', $('#newsletter_scroll').height()+444);
                }

                //$('#newsletter_scroll').css('height', $('#newsletter_scroll').height()+777);



                this.newsletterList = this.newsletterList.concat(response.newsletter);


              }









              // response.newsletter.forEach(element => {



              //    this.newsletterList.push(element);



              // });




               this.page_load_newsletter =true;








            }else if(response.newsletter.length ==0 && this.newsletter_offset !=0){




             // this.newsletterList = this.newsletterList ;





              this.page_load_newsletter =false;
            }




          }else{
           this.toast.error('Newsletter List Not Found  !', '', {timeOut: 3000});
          }


        })

      }


    }catch(exec){

    }

  }



  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };


    // this.getSearchValue();

  }

  ngAfterViewInit(){



    $(window).on("scroll", function(e) {








      if(this._router.url == '/search' || (this._router.url.indexOf('/search?category')>=0)){






        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {





          if(this.currentTab ==1){


            if(this.page_load_article ){

             // console.log(this.article_offset);





              this.page_load_article =false;



              //this.categoryLazyList(this.record_offset);

              this.callApi(1);

             this.article_offset+=this.per_page;


            }



          } else{



            if(this.page_load_newsletter){




             // console.log('rr',this.newsletter_offset);


            this.page_load_newsletter =false;



              this.callApi(2);

              this.newsletter_offset+=this.per_page;



              //this.categoryLazyList(this.record_offset);

            }



          }




        }




      }





    }.bind(this));









    $('#datepairExample .date').datepicker({

      format: 'yyyy-mm-dd',
      autoclose: true,
      startView: "date",
      minViewMode: "date",
      // startDate:  moment().format('YYYY-MM-DD'),

    }).on('changeDate', function(e) {

      this.articleFrom = e.format();
      this.changeArticleFrom();

      $('datepairExample').addClass('value-exists')

       $('datepairExample').datepicker('update');

  }.bind(this));


  $('#datepairExample1 .date').datepicker({

    format: 'yyyy-mm-dd',
    autoclose: true,
    startView: "date",
    minViewMode: "date",
    // startDate:  moment().format('YYYY-MM-DD'),

  }).on('changeDate', function(e) {

    this.articleTo = e.format();
    this.changeArticleTo();

    $('datepairExample1').addClass('value-exists')

     $('datepairExample1').datepicker('update');

 }.bind(this));

 $('#datepairExample2 .date').datepicker({

  format: 'yyyy-mm-dd',
  autoclose: true,
  startView: "date",
  minViewMode: "date",
  // startDate:  moment().format('YYYY-MM-DD'),

}).on('changeDate', function(e) {

  this.newsFrom = e.format();
  this.changeNewsFrom();

  $('datepairExample2').addClass('value-exists')

   $('datepairExample2').datepicker('update');

}.bind(this));


$('#datepairExample3 .date').datepicker({

  format: 'yyyy-mm-dd',
  autoclose: true,
  startView: "date",
  minViewMode: "date",
  // startDate:  moment().format('YYYY-MM-DD'),

}).on('changeDate', function(e) {

  this.newsTo = e.format();
  this.changeNewsTo();

  $('datepairExample3').addClass('value-exists')

   $('datepairExample3').datepicker('update');

}.bind(this));



    $(function(){


      $('[data-toggle="tooltip"]').tooltip();
      $('input').blur(function(event) {
          var inputValue = this.value;
          if (inputValue) {
              this.classList.add('value-exists');
          } else {
              this.classList.remove('value-exists');
          }
      });
      //comments left sidebar
      $(".comments").click(function(event) {
          event.stopPropagation();
          $("#comments_left_sidebar").addClass("menu-open");
          //$(".main-menu").addClass("mob-menu-bg");
      });
      $(".msg-box-close").click(function() {
          $("#comments_left_sidebar").removeClass("menu-open");
          //$(".main-menu").removeClass("mob-menu-bg");
      });
      $('body').click(function() {
          $("#comments_left_sidebar").removeClass("menu-open");
          $(".main-menu").removeClass("mob-menu-bg");
      });

      //popover
      //popover
      $("[data-toggle=popover]").popover({
          html: true,
          trigger: 'click',
          content: function() {
              var content = $(this).attr("data-popover-content");
              return $(content).children(".popover-body").html();
          }
      });



    });

  }

  broadcast_menu(){

    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});

  }

  ngOnDestroy(){



    this.msg.sendMessage({'type':'reset_search'});

    this.subscription.unsubscribe();

   }

   viewArticle(id:number){

    this.msg.sendMessage({'type':'searchvalue','details':this.search});
    this._router.navigate(['/article/'+id+'/view']);
  }


  get_category_type(type:string,indx:any){

    // console.log('tdtdtd',type)

    let typestr = this.categoryList.find( (item) =>{ return item.key == type;});

    let categoryList = this.articleList[indx].category

    if(typestr==undefined){
      var index = categoryList.indexOf(type);
      if (index > -1) {
        categoryList.splice(index, 1);
      }
      this.articleList[indx].category = categoryList
    }

     return (typestr!=undefined)?typestr.value:'';

  }



}
